import React from 'react';
import PublicationStat from './PublicationStat/PublicationStat';

export default function PublicationCitationStat({ citationCount }) {
  return (
    <PublicationStat
      value={citationCount}
      caption="Citations"
      tip="Citations of this article."
      data-name="citation-stat"
    />
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/PublicationCitationStat.js